$ = jQuery;

// Parse the URL
function getParameterByName(name) {
  name = name.replace(/[\[], '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
  results = regex.exec(location.search);
  return results === null
  ? ''
  : decodeURIComponent(results[1].replace(/\+/g, ' '));
}
// Give the URL parameters variable names
var source = getParameterByName('utm_source');
var medium = getParameterByName('utm_medium');
var campaign = getParameterByName('utm_campaign');

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

// store values to session
if (source != "") {
  sessionStorage.setItem("utm_source", source);
  sessionStorage.setItem("utm_medium", medium);
  sessionStorage.setItem("utm_campaign", campaign);
}
// check if source is already in cookie
var source_cookie = sessionStorage.getItem("utm_source");
var medium_cookie = sessionStorage.getItem("utm_medium");
var campaign_cookie = sessionStorage.getItem("utm_campaign");

if (source_cookie != null) {
  // Save utm to array for anchor
  var utm_parameters = ['utm_source=' + source_cookie, 'utm_medium=' + medium_cookie, 'utm_campaign=' + campaign_cookie];
  $(".story").attr("href", $(".story").attr("href") + "?" + utm_parameters[0] + "&" + utm_parameters[1] + "&" + utm_parameters[2])
}
